/**
 * Drive-root folder id helpers.
 *
 * Pure functions with no React / component dependencies, so they're safe
 * to import from anywhere — including `PickerNavigator` — without creating
 * an import cycle. `FolderPickerDialog` re-exports both for
 * backwards-compatible `./FolderPickerDialog` imports.
 */

/** Build the deterministic root folder ID for a tenant. */
export function getRootFolderId(tenantId: string): string {
  return `papan_${tenantId}`
}

/** Check whether a folder ID is a papan root folder. */
export function isRootFolderId(id: string): boolean {
  return id.startsWith('papan_')
}
